import { render, staticRenderFns } from "./LogoutView.vue?vue&type=template&id=3c975c2c&"
import script from "./LogoutView.vue?vue&type=script&lang=ts&"
export * from "./LogoutView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports